import { GlobalRole, Id, ListState, OrganizationInvite, OrganizationJoinRequest, SuccessResponse } from '../types';
import { abibApi, tags, methods } from './';

// '/globalRoles': {
//     '/': 'get', // getAllGlobalRoles
//     '/': 'post', // createGlobalRole
//     '/{globalRole}': 'get', // getGlobalRole
//     '/{globalRole}': 'put', // updateGlobalRole
//     '/{globalRole}': 'delete', // deleteGlobalRole

//     '/{globalRole}/assignGlobalRole/{globalRole}': 'put', // assignGlobalRole
//   };
const apiGlobalRole = abibApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllGlobalRoles: builder.query<{ items: GlobalRole[] }, void>({
      query: () => {
        return {
          method: methods.GET,
          url: `/globalRoles`,
        };
      },
      providesTags: (result, error, arg) => [{ type: tags.globalRoleList }],
      transformResponse: ({ data }, meta, arg) => ({
        items: data
      }),
    }),
    createGlobalRole: builder.mutation<SuccessResponse, Omit<GlobalRole, 'id'>>({
      query: (globalRole) => {
        return {
          method: methods.POST,
          url: `/globalRoles`,
          body: globalRole,
        };
      },
      invalidatesTags: (result, error, globalRole) => [{ type: tags.globalRoleList }],
      transformResponse: ({ data }, meta, arg) => data,
    }),
    getGlobalRole: builder.query<GlobalRole, { global_role_id: Id }>({
      query: ({ global_role_id }) => {
        return {
          method: methods.GET,
          url: `/globalRoles/${global_role_id}`,
        };
      },
      providesTags: (result, error, { global_role_id }) => [{ type: tags.globalRole, global_role_id }],
      transformResponse: ({ data }, meta, arg) => data,
    }),
    updateGlobalRole: builder.mutation<GlobalRole, { global_role_id: Id, globalRole: Partial<GlobalRole> }>({
      query: ({ global_role_id, globalRole }) => {
        return {
          method: methods.PUT,
          url: `/globalRoles/${global_role_id}`,
          body: globalRole,
        };
      },
      invalidatesTags: (result, error, { global_role_id, globalRole }) => [tags.globalRoleList, { type: tags.globalRole, global_role_id }],
      transformResponse: ({ data }, meta, arg) => data,
    }),
    deleteGlobalRole: builder.mutation<SuccessResponse<void>, { global_role_id: Id }>({
      query: ({ global_role_id }) => {
        return {
          method: methods.DELETE,
          url: `/globalRoles/${global_role_id}`,
        };
      },
      invalidatesTags: (result, error, { global_role_id }) => [tags.globalRoleList, { type: tags.globalRole, global_role_id }],
    }),
  }),
  overrideExisting: false,
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAllGlobalRolesQuery,
  useCreateGlobalRoleMutation,
  useGetGlobalRoleQuery,
  useUpdateGlobalRoleMutation,
  useDeleteGlobalRoleMutation,
} = apiGlobalRole;
